import { ColumnConfig } from '@/components/table/Table';
import { AuthorizationTransition } from '../models';
import {
  AUTHORIZATION_STATUS_LABELS,
  AUTHORIZATION_STATUS_CHIP_CLASSES,
  DEFAULT_STATUS_CHIP_CLASS,
  AUTHORIZATION_STATUS_DOT_CLASSES,
  DEFAULT_STATUS_DOT_CLASS,
} from './statusChip';
import { formatDate } from '@/utils';

export const getAuthorizationsTableColumns = (
  onReasonClick: (reason: string) => void
): ColumnConfig[] => {
  return [
    {
      label: 'Checkpoint',
      field: 'transition',
      render: (_value: unknown, rowData: AuthorizationTransition) => {
        return rowData.transition?.name || '-';
      },
    },
    {
      label: 'Conductor',
      field: 'requestDriver',
      render: (_value: unknown, rowData: AuthorizationTransition) => {
        const driver = rowData.requestDriver;
        if (!driver) return '-';
        return (
          `${driver.firstName || ''} ${driver.lastName || ''}`.trim() || '-'
        );
      },
    },
    {
      label: 'Estado',
      field: 'status',
      render: (value: string) => {
        const label = AUTHORIZATION_STATUS_LABELS[value] || value;
        const chipClass =
        AUTHORIZATION_STATUS_CHIP_CLASSES[value] || DEFAULT_STATUS_CHIP_CLASS;
        const dotClass =
        AUTHORIZATION_STATUS_DOT_CLASSES[value] || DEFAULT_STATUS_DOT_CLASS;
        return (
          <span
          className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-sm font-semibold ${chipClass}`}
          >
            <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotClass}`} />
            {label}
          </span>
        );
      },
    },
    {
      label: 'Autorizado por',
      field: 'authorizationUser',
      render: (_value: unknown, rowData: AuthorizationTransition) => {
        if (rowData.status === 'ACCEPTED_NO_DISCREPANCIES') {
          return 'Autorizado vía sistema';
        }
        const user = rowData.authorizationUser;
        if (!user) return '-';
        return (
          `${user.firstName || ''} ${user.lastName || ''}`.trim() || '-'
        );
      },
    },
    {
      label: 'Motivo',
      field: 'authorizationReason',
      render: (_value: unknown, rowData: AuthorizationTransition) => {
        const reason = rowData.authorizationReason;
        if (!reason) return <span className='text-gray-400'>-</span>;
        return (
          <span
            className='truncate text-sm text-gray-700 cursor-pointer hover:underline max-w-[200px] block'
            onClick={(e) => { e.stopPropagation(); onReasonClick(reason); }}
          >
            {reason}
          </span>
        );
      },
    },
    {
      label: 'Fecha Solicitud',
      field: 'createdAt',
      sortable: true,
      render: (value: string) => {
        return formatDate(value);
      },
    },
    {
      label: 'Fecha Resolución',
      field: 'authorized',
      sortable: true,
      render: (value: string | null) => {
        return value ? formatDate(value) : '-';
      },
    },
  ];
};
